/**
 * Sends a logged-out visitor to the login page while remembering where they were going.
 *
 * Used by the router's catch-all and by the legacy sign-in path. Both used to navigate to
 * the public chat bare, which silently discarded the destination — and with `replace`, the
 * original URL was gone from history too. Anything mailed as a deep link (a feedback ticket,
 * a campaign) therefore died at the login screen even though the login itself succeeded.
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router';
import { getPublicAuthRedirectTarget } from 'utils/auth-redirect';

const RedirectToLogin: React.FC = () => {
  const location = useLocation();
  return <Navigate to={getPublicAuthRedirectTarget(location)} state={{ from: location }} replace />;
};

export default RedirectToLogin;
